// src/assessment2/competencyScoreUtils.js
//
// Helpers para leer el score y la cobertura de una competencia dentro de un
// assessment.
//
// La fuente de verdad del score es `competencyScores` en la raíz de la respuesta.
// Los assessments generados antes de que ese campo se poblara sólo tienen el dato
// duplicado dentro de cada pregunta, por eso se mantiene el fallback.

/**
 * Score final de una competencia (0-100).
 * @param {Object} data Respuesta completa de la evaluación
 * @param {Object} capability Capability dentro de data.capabilities
 * @returns {number}
 */
export const getCompetencyScore = (data, capability) => {
    if (!capability) return 0;

    const rootScores = Array.isArray(data?.competencyScores) ? data.competencyScores : null;

    if (rootScores) {
        const match = rootScores.find(c => c.competencyId === capability.capabilityId);
        if (match && typeof match.competencyScore === 'number') {
            return match.competencyScore;
        }
    }

    // Fallback para assessments antiguos
    return capability.questions?.[0]?.competencyScore || 0;
};

/**
 * Cantidad de preguntas efectivamente respondidas por el candidato.
 * @param {Object} capability
 * @returns {number}
 */
export const getAnsweredQuestionsCount = (capability) => {
    if (!Array.isArray(capability?.questions)) return 0;

    return capability.questions.filter(
        q => typeof q.answerText === 'string' && q.answerText.trim() !== ''
    ).length;
};

/**
 * Total de preguntas de la competencia.
 * @param {Object} capability
 * @returns {number}
 */
export const getTotalQuestionsCount = (capability) => {
    if (!Array.isArray(capability?.questions)) return 0;
    return capability.questions.length;
};
